import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ShiftKind } from '../../utils/column-generator';

@Component({
  selector: 'app-shift-icon',
  standalone: true,
  template: `
    @switch (kind()) {
      @case ('morning') {
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M8 1.5v5M5.8 3.7 8 1.5l2.2 2.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.5 12a4.5 4.5 0 0 1 9 0" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
          <path d="M1.5 14.5h13M1.8 9.2l1.2.7M14.2 9.2l-1.2.7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
      }
      @case ('night') {
        <svg viewBox="0 0 16 16" aria-hidden="true">
          <path d="M9.6 1.6a6.5 6.5 0 1 0 4.8 10.9A5.6 5.6 0 0 1 9.6 1.6Z" fill="currentColor"/>
        </svg>
      }
      @default {
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="2.6" fill="currentColor"/>
          <path d="M8 1.2v1.8M8 13v1.8M1.2 8H3M13 8h1.8M3.2 3.2l1.3 1.3M11.5 11.5l1.3 1.3M3.2 12.8l1.3-1.3M11.5 4.5l1.3-1.3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
      }
    }
  `,
  styles: [`
    :host {
      display:     inline-flex;
      width:       var(--shift-icon-size, 0.875rem);
      height:      var(--shift-icon-size, 0.875rem);
      color:       var(--shift-icon-color, var(--c-epc-rose, #E92184));
      flex-shrink: 0;
    }
    svg { width: 100%; height: 100%; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftIconComponent {
  readonly kind = input.required<ShiftKind>();
}
